import { Injectable } from '@angular/core';
import { KeycloakConfiguration } from '@models/online-reputation.models';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class KeycloakService {

  private _keycloak!: Keycloak;

  init(config: KeycloakConfiguration): Promise<unknown> {
    return new Promise((resolve, reject) => {
      try {
        this._keycloak = new Keycloak(config);
        console.log("Keycloak DONE", this._keycloak)
        resolve(this._keycloak.init({
          onLoad: 'login-required',
          silentCheckSsoRedirectUri: `${ window.location.origin }/silent-check-sso.html`,
          enableLogging: true,
          pkceMethod: 'S256'
        }));
      } catch (error) {
        reject(error);
      }
    });
  }

  loadUserInfo() {
    return this._keycloak.loadUserInfo();
  }

  loadUserProfile() {
    return this._keycloak.loadUserProfile();
  }

  logout() {
    return this._keycloak.logout();
  }

  realmAccess() {
    return this._keycloak.realmAccess;
  }

  resourceAccess() {
    return this._keycloak.resourceAccess;
  }

  bearerToken(): string {
    return this._keycloak?.token || '';
  }

  clientId(): string {
    return this._keycloak?.clientId || '';
  }

  updateToken (minValidity?: number): Promise<boolean> {
    if(!this._keycloak) {
      return Promise.resolve(false);
    }
    return this._keycloak.updateToken(minValidity);
  }

  onTokenExpired(callback: () => void) {
    this._keycloak.onTokenExpired = callback
  }

}
